import { Controller } from "@hotwired/stimulus"
import { Chart } from "chart.js/auto"
import "chartjs-adapter-date-fns"

export default class extends Controller {
  static targets = ["canvas"]
  static values = { data: Object }

  connect() {
    const config = {
      post_impressions: { borderColor: "rgb(16, 185, 129)", label: "Post impressions", yAxisID: "y" },
      followers: { borderColor: "rgb(59, 130, 246)", label: "Followers", yAxisID: "y" },
      profile_viewers: { borderColor: "rgb(249, 115, 22)", label: "Profile viewers", yAxisID: "y2" }
      
    }

    const datasets = Object.entries(this.dataValue)
      .filter(([_, points]) => points.length > 0)
      .map(([key, points]) => ({
        label: config[key].label,
        data: points.map(p => ({ x: p.x + "T00:00:00Z", y: p.y })),
        borderColor: config[key].borderColor,
        backgroundColor: config[key].borderColor,
        yAxisID: config[key].yAxisID,
        fill: false,
        tension: 0.3,
        pointRadius: 2,
        pointHoverRadius: 6,
        borderWidth: 2
      }))

    new Chart(this.canvasTarget, {
      type: "line",
      data: { datasets },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: { padding: { bottom: 20 } },
        interaction: { mode: "index", intersect: false },
        scales: {
          x: {
            type: "time",
            time: { tooltipFormat: "MMM d, yyyy" },
            title: { display: false }
          },
          y: {
            position: "left",
            title: { display: true, text: "Followers / Impressions" },
            beginAtZero: true
          },
          y2: {
            position: "right",
            title: { display: true, text: "Viewers" },
            beginAtZero: true,
            grid: { display: false }
          }
        }
      }
    })
  }
}
